import React, { useState } from 'react';
import { Search, Bell, User, Settings, LogOut, Menu, X } from 'lucide-react';
import { useSession } from '../contexts/SessionContext';
import './AdminNavbar.css';

const AdminNavbar = ({ activeTab, setActiveTab, userEmail, onToggleSidebar, sidebarCollapsed, children }) => {
  const { logout } = useSession();
  const [searchQuery, setSearchQuery] = useState('');
  const [showNotifications, setShowNotifications] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);

  const notifications = [
    { id: 1, title: 'New vendor registration', message: 'Fresh Foods Co. has registered', time: '2 min ago', unread: true },
    { id: 2, title: 'Order completed', message: 'Order #1234 has been delivered', time: '5 min ago', unread: true },
    { id: 3, title: 'Low stock alert', message: 'Organic Apples running low', time: '1 hour ago', unread: false },
    { id: 4, title: 'System update', message: 'Platform updated to v2.1.0', time: '2 hours ago', unread: false }
  ];

  const unreadCount = notifications.filter(n => n.unread).length;

  const handleSearch = (e) => {
    e.preventDefault();
    // Handle search functionality
    console.log('Searching for:', searchQuery);
  };

  return (
    <div className="admin-navbar">
      <div className="admin-navbar-content">
        <div className="admin-navbar-left">
          <button 
            className="admin-menu-toggle"
            onClick={onToggleSidebar}
          >
            {sidebarCollapsed ? <Menu size={20} /> : <X size={20} />}
          </button>
          <div className="admin-brand" aria-label="Brand">
            <span className="admin-brand-text">SonicKart</span>
          </div>

          <div className="admin-navbar-nav">
            <div className="admin-nav-tabs">
              <button 
                className={`admin-nav-tab ${activeTab === 'dashboard' ? 'active' : ''}`}
                onClick={() => setActiveTab('dashboard')}
              >
                Dashboard
              </button>
              <button 
                className={`admin-nav-tab ${activeTab === 'vendors' ? 'active' : ''}`}
                onClick={() => setActiveTab('vendors')}
              >
                Vendors
              </button>
              <button 
                className={`admin-nav-tab ${activeTab === 'products' ? 'active' : ''}`}
                onClick={() => setActiveTab('products')}
              >
                Products
              </button>
              <button 
                className={`admin-nav-tab ${activeTab === 'orders' ? 'active' : ''}`}
                onClick={() => setActiveTab('orders')}
              >
                Orders
              </button>
            </div>
          </div>
        </div>

        <div className="admin-navbar-center">
          <form onSubmit={handleSearch} className="admin-search-form">
            <div className="admin-search-container">
              <Search size={20} className="admin-search-icon" />
              <input
                type="text"
                placeholder="Search vendors, products, orders..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="admin-search-input"
              />
            </div>
          </form>
        </div>

        <div className="admin-navbar-right">
          <div className="admin-navbar-actions">
            <div className="admin-notifications">
              <button 
                className="admin-notification-btn"
                onClick={() => setShowNotifications(!showNotifications)}
              >
                <Bell size={20} />
                {unreadCount > 0 && (
                  <span className="admin-notification-badge">{unreadCount}</span>
                )}
              </button>
              
              {showNotifications && (
                <div className="admin-notifications-dropdown">
                  <div className="admin-notifications-header">
                    <h3>Notifications</h3>
                    <button 
                      className="admin-mark-all-read"
                      onClick={() => setShowNotifications(false)}
                    >
                      Mark all as read
                    </button>
                  </div>
                  <div className="admin-notifications-list">
                    {notifications.map((notification) => (
                      <div 
                        key={notification.id} 
                        className={`admin-notification-item ${notification.unread ? 'unread' : ''}`}
                      >
                        <div className="admin-notification-content">
                          <h4>{notification.title}</h4>
                          <p>{notification.message}</p>
                          <span className="admin-notification-time">{notification.time}</span>
                        </div>
                        {notification.unread && <div className="admin-notification-dot"></div>}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Session Status Component */}
            {children}

            <div className="admin-user-menu">
              <button 
                className="admin-user-btn"
                onClick={() => setShowUserMenu(!showUserMenu)}
              >
                <div className="admin-user-avatar">
                  <User size={16} />
                </div>
                <span className="admin-user-name">Admin</span>
              </button>
              
              {showUserMenu && (
                <div className="admin-user-dropdown">
                  <div className="admin-user-info">
                    <div className="admin-user-avatar-large">
                      <User size={20} />
                    </div>
                    <div>
                      <h4>Admin User</h4>
                      <p>{userEmail}</p>
                    </div>
                  </div>
                  <div className="admin-user-menu-items">
                    <button className="admin-user-menu-item">
                      <User size={16} />
                      Profile
                    </button>
                    <button className="admin-user-menu-item">
                      <Settings size={16} />
                      Settings
                    </button>
                    <button 
                      className="admin-user-menu-item logout"
                      onClick={logout}
                    >
                      <LogOut size={16} />
                      Logout
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminNavbar;
